module.exports = __webpack_public_path__ + "static/media/bundle.b03f4433.png";